import { View, Text } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { useThemeColors } from "@/providers/ThemeProvider";

/**
 * Chat screen placeholder
 * TODO: Implement chat functionality (Phase 5)
 */
export default function ChatScreen() {
  const colors = useThemeColors();

  return (
    <SafeAreaView className="flex-1" style={{ backgroundColor: colors.background }}>
      <View className="flex-1 items-center justify-center px-6">
        <Text className="text-2xl font-bold mb-2" style={{ color: colors.text }}>
          💬 Chat
        </Text>
        <Text className="text-center" style={{ color: colors.textSecondary }}>
          Chat functionaliteit komt binnenkort beschikbaar.
        </Text>
      </View>
    </SafeAreaView>
  );
}
